export default {"src":"/_next/static/media/otp.8ee1db0c.svg","height":96,"width":120,"blurWidth":0,"blurHeight":0};